import React from 'react';
import { Text, TextButton, Box, Heading, IconElement } from '@wix/design-system';
import { Refresh } from "@wix/wix-ui-icons-common";
import { useTranslation } from '@wix/wix-i18n-config';
import { ErrorConeSvg } from '@wix/gg-components';
import { useViewport } from '../../hooks/useViewport';
import s from './ErrorConePage.scss';
import classNames from 'classnames';
import { dataHooks } from './dataHooks';

type ErrorConePageProps = {
  titleKey: string;
  subtitleKey: string;
  withTryAgain: boolean;
  tryAgainKey?: string;
  onTryAgain?: () => void;
  additionalActionKey?: string;
  additionalAction?: () => void;
  additionalActionPrefixIcon?: IconElement;
  errorName?: string;
};

const ErrorConePage: React.FC<ErrorConePageProps> = ({
  titleKey,
  subtitleKey,
  withTryAgain,
  tryAgainKey,
  onTryAgain,
  additionalActionKey,
  additionalAction,
  additionalActionPrefixIcon = undefined,
  errorName = 'Generic_Error',
}) => {
  const { t } = useTranslation();
  const { isDesktop, isMobile } = useViewport();

  // useEffect(() => {
  //   biLogger.errorShown(errorName);
  // }, []);

  return (
    <Box
      direction="vertical"
      align="center"
      verticalAlign={isDesktop ? 'middle' : 'top'}
      textAlign="center"
      boxSizing="border-box"
      padding="SP3"
      height="100%"
      width="100%"
      className={classNames(s.errorConePage, {
        [s.mobile]: isMobile,
      })}
      dataHook={dataHooks.root}
    >
      <Box marginBottom={2}>
        <ErrorConeSvg />
      </Box>
      <Box gap={20} direction="vertical" marginBottom={1}>
        <Heading size="large" weight="bold">
          {t(titleKey)}
        </Heading>
      </Box>
      <Box gap={20} direction="vertical" marginBottom={2}>
        <Text size="small" color="secondary">
          {t(subtitleKey)}
        </Text>
      </Box>
      <Box>
        {withTryAgain ? (
          <Box marginRight={1}>
            <TextButton
              dataHook={dataHooks.tryAgainButton}
              onClick={() => {
                onTryAgain ? onTryAgain() : window.location.reload();
              }}
              prefixIcon={<Refresh />}
              as="button"
              size="small"
            >
              {t(tryAgainKey ?? `TRY_AGAIN_IDEA_ERROR`)}
            </TextButton>
          </Box>
        ) : null}
        {additionalAction && (
          <Box marginLeft={1}>
            <TextButton
              as="button"
              size="small"
              onClick={() => additionalAction?.()}
              prefixIcon={additionalActionPrefixIcon}
              dataHook={dataHooks.additionalActionButton}
            >
              {t(additionalActionKey)}
            </TextButton>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ErrorConePage;
